import api from "./api";

const PRICE_BASE = "/DeliveryPrice";
const HISTORY_BASE = "/DeliveryHistory";

export const calculateDeliveryCost = async (payload) => {
    if (!payload?.originAddressId || !payload?.destinationAddressId) {
        throw new Error("originAddressId and destinationAddressId are required");
    }

    try {
        const res = await api.post(`${PRICE_BASE}/calculate`, {
            originAddressId: payload.originAddressId,
            destinationAddressId: payload.destinationAddressId,
        });

        return res.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message ||
            error?.message ||
            "Failed to calculate delivery cost"
        );
    }
};

export const getDeliveryHistory = async () => {
    const res = await api.get(HISTORY_BASE);
    return res.data;
};

export const getDeliveryHistoryById = async (id) => {
    const res = await api.get(`${HISTORY_BASE}/${id}`);
    return res.data;
};

export default {
    calculateDeliveryCost,
    getDeliveryHistory,
    getDeliveryHistoryById,
};